import React from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Link from 'shared/components/Link/Link';
import { FormattedMessage, injectIntl, intlShape } from 'react-intl';
import arrowDown from 'shared/assets/images/down-arrow-angle.svg';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import arrowUp from 'shared/assets/images/up-arrow-angle.svg';
import crossUrl from 'shared/assets/images/cross-black.svg';
import googletag from 'shared/modules/googletag/googletag';
import { numberWithSpaces } from 'shared/helpers/common';

import ShowFilterButtonLine from '../ShowFilterButtonLine/ShowFilterButtonLine';
import SaveSearch from '../SaveSearch/SaveSearch';

import s from './SearchFormBottom.css';

const isMobile = __APP__ === 'mobile';
class SearchFormBottom extends React.Component {
  static propTypes = {
    collapsed: PropTypes.bool.isRequired,
    handleClick: PropTypes.func.isRequired,
    count: PropTypes.number,
    handleClearForm: PropTypes.func.isRequired,
    onClickBottom: PropTypes.func.isRequired,
    url: PropTypes.string.isRequired,
    // expandable: PropTypes.bool.isRequired,
    searchable: PropTypes.bool.isRequired,
    cardTypes: PropTypes.string.isRequired,
    // isLoading: PropTypes.bool.isRequired,
    loading: PropTypes.bool,
    isCollapsed: PropTypes.bool,
    //
    intl: intlShape.isRequired,
  };
  static defaultProps = {
    loading: false,
    isCollapsed: false,
    count: 0,
    onClickBottom: () => {},
  };
  state = {
    slots: [
      {
        dfpNetworkId: '78780000',
      },
    ],
  };
  handleChange = (key, data) => {
    const fun = {
      refresh: () => {
        googletag({
          googletagRefresh: true,
        });
      },
    };
    if (fun[key]) {
      fun[key](data);
    } else {
      console.error(key);
    }
  };

  render() {
    const {
      collapsed,
      handleClick,
      // expandable,
      searchable,
      count,
      url,
      handleClearForm,
      cardTypes,
      intl,
      onClickBottom,
      loading,
      isCollapsed,
    } = this.props;

    const rootClass = isMobile ? s.rootMobile : s.root;

    return (
      <div
        className={rootClass}
        onClick={() => {
          onClickBottom();
          this.handleChange('refresh');
        }}
      >
        <div className={s.flexRow}>
          <div className={s.innerLeft}>
            {isCollapsed &&
              collapsed &&
              <div className={s.dividerWrapper}>
                <ShowFilterButtonLine collapsed={collapsed} handleClick={handleClick} />
              </div>}
            <button className={s.clear} onClick={handleClearForm}>
              <img
                src={crossUrl}
                width={12}
                className={s.imgClear}
                alt={intl.formatMessage({ id: 'Сбросить фильтры' })}
              />
              <FormattedMessage id="Очистить" />
            </button>
          </div>
          <div className={s.innerRight}>
            {searchable &&
              <div className={s.left}>
                <SaveSearch isFirstRender />
              </div>}
            <div className={s.right}>
              <span>
                {count > 0 &&
                  <Link
                    rel="nofollow"
                    to={url}
                    className={s.searchBtn}
                    data-lens-event="searchClick"
                  >
                    <FormattedMessage id="Показать" /> {numberWithSpaces(count || 0)} {cardTypes}
                  </Link>}
                {count === 0 &&
                  <span className={cx(s.searchBtn, s.disabled)}>
                    <FormattedMessage id="Не найдено" /> {cardTypes}
                  </span>}
              </span>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withStyles(s)(
  connect(({ loading: { start } = {} }) => ({ loading: Boolean(start) }))(
    injectIntl(SearchFormBottom),
  ),
);



// WEBPACK FOOTER //
// ./src/desktop/components/SearchPanelV2/SearchFormBottom/SearchFormBottom.js